import { render, staticRenderFns } from "./navheader.vue?vue&type=template&id=aa7dd0f4&scoped=true&"
import script from "./navheader.vue?vue&type=script&lang=js&"
export * from "./navheader.vue?vue&type=script&lang=js&"
import style0 from "./navheader.vue?vue&type=style&index=0&id=aa7dd0f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7dd0f4",
  null
  
)

export default component.exports